import { TimeshiftUtil } from './TimeshiftUtil';

/**
 * Export module
 */

const Timeshift = {
    getNowEvent: TimeshiftUtil.getNowEvent,
    hasTimeshift: TimeshiftUtil.hasTimeshift,
    timeRangeIsInCurrent: TimeshiftUtil.timeRangeIsInCurrent,
    ifFireProgressForTimeshift: TimeshiftUtil.ifFireProgressForTimeshift,
    replaceCatchupTime: TimeshiftUtil.replaceCatchupTime,
    getPlayerWatermarkData: TimeshiftUtil.getPlayerWatermarkData,
    initPlayerWaterMark: TimeshiftUtil.initPlayerWaterMark,
    playerWatermarkEnabled: TimeshiftUtil.playerWatermarkEnabled,
    calcTSExcedecTime: TimeshiftUtil.calcTSExcedecTime
};

export { Timeshift };



// WEBPACK FOOTER //
// ./src/AAF/Timeshift/main.js